import { render, staticRenderFns } from "./prematriculaResume.vue?vue&type=template&id=06578819&"
import script from "./prematriculaResume.vue?vue&type=script&lang=js&"
export * from "./prematriculaResume.vue?vue&type=script&lang=js&"
import style0 from "./prematriculaResume.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports